import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	fill: "none",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M22.5 27a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9zm4.968-.307a6.5 6.5 0 1 0-1.514 1.315l3.996 3.996 1.414-1.414-3.896-3.897z",
		clipRule: "evenodd"
	})
});
export default SvgIconSearch;
